import React from 'react';

import { Box } from '@mui/system';
import { makeStyles } from '@mui/styles';
import Typography from '../Typography/Typography';

export default function Banner(props) {
  const { bannerData } = props;

  const useStyles = makeStyles({
    root: {
      width: '100%',
      backgroundColor: '#fcfcff',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      // border: 'solid 1px',
    },
    bannerImage: {
      width: '100%',
      '@media only screen and (max-width: 768px)': {
        display: 'none',
      },
      // height: '320px',
    },
    textBox: {
      width: '100%',
      maxWidth: '1280px',
      marginBottom: '88px',
      paddingTop: '88px',
      boxSizing: 'border-box',
      '@media only screen and (max-width: 1280px)': {
        paddingTop: '16px',
        paddingLeft: '32px',
        paddingRight: '32px',
      },
      '@media only screen and (max-width: 768px)': {
        paddingLeft: '32px',
        paddingRight: '32px',
        marginBottom: '16px',
      },
    },
    title: {
      fontFamily: 'Pretendard',
      fontSize: '40px',
      fontWeight: 600,
      textAlign: 'left',
      color: '#191919',
      marginBottom: '52px',
      '@media only screen and (max-width: 768px)': {
        marginBottom: '32px',
        fontSize: '24px',
      },
    },
    text: {
      fontFamily: 'Pretendard',
      fontSize: '20px',
      lineHeight: 1.2,
      letterSpacing: '-0.2px',
      textAlign: 'left',
      color: '#191919',
      '@media only screen and (max-width: 768px)': {
        fontSize: '16px',
        lineHeight: 1.25,
      },
    },
    bannerImageM: {
      display: 'none',
      width: '100%',
      '@media only screen and (max-width: 768px)': {
        display: 'flex',
      },
    },
  });

  const classes = useStyles();

  return (
    <Box className={classes.root}>
      {/* <Box className={classes.imgBox} /> */}
      <img className={classes.bannerImage} src={bannerData.imgSrc} alt='test' />
      <img className={classes.bannerImageM} src={bannerData.imgSrcM} alt='test' />

      <Box className={classes.textBox} style={!bannerData.text1 && !bannerData.text2 ? { marginBottom: 0 } : {}}>
        <Typography className={classes.title}>{bannerData.title}</Typography>
        <Typography className={classes.text}>{bannerData.text1}</Typography>
        <Typography className={classes.text}>{bannerData.text2}</Typography>
      </Box>
    </Box>
  );
}
